module.exports = "/assets/gift-events-listing/XMAS24-banner-desktop.png?MXpQ88F";